module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa54554c0fcb164671e7970adfc280ca8.a54554c0.png";